// extracted by mini-css-extract-plugin
module.exports = {"chip":"scroll-to-top-button_chip__Um8r7","chipHidden":"scroll-to-top-button_chipHidden__aQB8x"};